<template>
  <button
    v-bind:class="{'btn btn-close':true,'scale-btn':scale}"
    ondragstart="return false;"
    @click="handleClick"
    @touchstart="handleScale"
    @mousedown="handleScale"
    @mouseup="handleRestore"
    @mouseout="handleRestore"
    @touchcancel="handleRestore"
    @touchend="handleRestore"
    @gesturestart="handleGesturestart"
  >{{text}}</button>
</template>
<script>
export default {
  name: "btn",
  props: {
    text: {
      type: String,
      default: "确定",
    },
  },
  data() {
    return {
      scale: false,
    };
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
    handleScale() {
      this.scale = true;
    },
    handleRestore() {
      this.scale = false;
    },
    handleGesturestart(e) {
      e.preventDefault();
    }
  },
};
</script>

<style lang="scss" scoped>
.btn {
  cursor: pointer;
  height: 0.33rem;
  width: 1.44rem;
  margin: 0 auto;
  background: url(~@/assets/img/UI_common_button_green_01.png) no-repeat;
  background-size: cover;
  display: block;
  line-height: 0.33rem;
  font-size: 0.12rem;
  color: #ffffff;
  display: block;
  text-align: center;
  touch-action: none;
}
.scale-btn {
  -webkit-transform: scale(0.95);
  transform: scale(0.95);
}
</style>